import React from "react";
import { FormattedMessage } from "react-intl";
import Modal from "../../../../../components/Modal";
import Form, { Title } from "../../../../../components/Form";
import { IProps } from "./types";
import messages from "./messages";

const SuccessModal = ({ onClose }: IProps) => {
    return (
        <Modal close={onClose}>
            <Title><FormattedMessage {...messages.title} /></Title>
            <p><FormattedMessage {...messages.description} /></p>
            <Form>
                <button className="button button--full-width" onClick={onClose}>
                    <FormattedMessage {...messages.close} />
                </button>
            </Form>
        </Modal>
    );
};

export default SuccessModal;
